var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"drill-report-jump-rope-chart"},[_c('h2',[_vm._v("跳绳速率图")]),_c('canvas',{ref:"chart",staticClass:"chart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }